(function(){
'use strict';

angular.module('classy').component('inputField', {
  template: '\n      <form-label      \n      required="$ctrl.required"\n      ng-if="$ctrl.label"\n      _spec="label"\n      id="{{ $ctrl.name}}_id">\n        {{ $ctrl.label }}\n      </form-label>\n\n      <span class="form__label--spacer"\n      ng-if="!$ctrl.label && !$ctrl.noSpacer"></span>      \n\n      <div class="form__text-input__outer" data-ng-class="{ \'admin-body__lock-field\': $ctrl.lockField }">\n        <div ng-if="$ctrl.lockField"\n        data-sc-tooltip-class="admin-campaign-tooltip lock-tooltip-msg"\n        data-sc-tooltip-position="center"\n        data-sc-tooltip-position-tip="bottom center"\n        show-event="\'mouseenter\'" hide-event="\'mouseout\'"\n        fixed-tooltip="true"\n        data-sc-tooltip="\'This field is locked at the template level.\'"\n        class="admin-body__tooltip-element"\n        ></div>\n        <input \n          class="form__text-input--dark {{$ctrl.styleClass}}"\n          ng-model="$ctrl.model"\n          ng-model-options="{ getterSetter: $ctrl.getterSetter }"\n          ng-required="$ctrl.required"\n          sc-retain-focus-validity\n          sc-validity-reporter\n          sc-validity-classes\n          pattern="{{:: $ctrl.pattern}}"\n          ng-pattern="$ctrl.pattern"\n          maxlength="{{:: $ctrl.maxlength }}"\n          ng-maxlength="{{:: $ctrl.maxlength }}"\n          minlength="{{:: $ctrl.minlength }}"\n          ng-minlength="{{:: $ctrl.minlength }}"\n          type="{{:: $ctrl.type }}"\n          name="{{:: $ctrl.name }}"\n          aria-label="{{:: $ctrl.ariaLabel }}"\n          autocomplete="{{:: $ctrl.autocomplete}}"\n          ng-disabled="$ctrl.disableFlag"\n          ng-change="$ctrl.onChange()"\n          placeholder="{{ $ctrl.placeholder }}"\n          qa-id="{{:: $ctrl.scQaId.singleLineTextInput }}"\n          _spec="input"\n          aria-labelledby="{{ $ctrl.name }}_id"\n        />\n        <span class="form__text-input__counter" ng-if="$ctrl.maxlength && $ctrl.counter && $ctrl.inputLength()">\n          <span data-ng-bind="$ctrl.inputLength()"></span>/{{::$ctrl.maxlength}}\n        </span>\n      </div>\n\n      <form-error\n      name="$ctrl.name"\n      messages="$ctrl.errorMessages"\n      _spec="errors"></form-error>\n    ',
  bindings: {
    model: '=',
    label: '<?',
    pattern: '=?',
    name: '<',
    maxlength: '<?',
    minlength: '<?',
    errorMessages: '<?',
    getterSetter: '<?',
    placeholder: '<?',
    required: '<?',
    type: '@?',
    disableFlag: '=?',
    counter: '<?',
    noSpacer: '<?',
    onChange: '&?',
    styleClass: '<?',
    ariaLabel: '@?',
    autocomplete: '@?',
    lockField: '<?'
  },
  controller: ["scQaId", "$element", "scCampaignsTemplateService", "$stateParams", "$attrs", function InputFieldCtrl(scQaId, $element, scCampaignsTemplateService, $stateParams, $attrs) {
    var DEFAULTS = {
      errorMessages: {
        required: 'This field is required.',
        url: 'Please provide a valid url',
        pattern: 'Please enter valid ' + this.label,
        maxlength: 'Please limit your answer to ' + $attrs.maxlength + ' characters or less'
      },
      getterSetter: false,
      placeholder: '',
      maxlength: false,
      minlength: false,
      required: false,
      type: 'text',
      counter: false,
      noSpacer: true
    };

    this.scQaId = scQaId;
    // This allows the character counter to work as expected with global/services/CQAnswerModel.js
    // which uses an overly complicated function as the model (and still work with ordinary strings)
    this.inputLength = function () {
      var model = this.model instanceof Function ? this.model() : this.model;
      return model ? model.length : null;
    };
    this.$onInit = function () {
      var _this = this;

      if (typeof this.lockField === 'undefined' && SC.campaign && SC.campaign.campaignTemplateData) {
        var getLockedField = function getLockedField(type) {
          _this.lockField = false;
          var lockedBlock = scCampaignsTemplateService.getBlockByType(type);
          if (lockedBlock) {
            var fieldName = $attrs.model.split('.').splice(-1)[0];
            if (_.includes(['dateAndTime', 'venueLocation', 'headline', 'venueAddress', 'subheading'], fieldName)) {
              _this.lockField = lockedBlock.item_attributes[fieldName] && lockedBlock.item_attributes[fieldName].locked;
            }
          }
        };
        var blockObj = _.find(SC.blocks, { id: $stateParams.blockId });
        if (blockObj) {
          getLockedField(blockObj.type);
        } else if ($stateParams.step === 'donation') {
          var lockDonationBlock = scCampaignsTemplateService.getBlockByType('donation');
          if (lockDonationBlock && $attrs.model === "DonationBlock.current['submit-button-text']") {
            this.lockField = lockDonationBlock.item_attributes['submit-button-text'].locked;
          }
        }

        /* only in case of campaign */
        if ($stateParams.step === 'team') {
          if ($attrs.model === 'campaign.current.default_team_appeal') {
            this.lockField = scCampaignsTemplateService.getCampaignSettingLock('default_team_appeal');
          }
          if ($attrs.model === 'campaign.current.default_team_post_title') {
            this.lockField = scCampaignsTemplateService.getCampaignSettingLock('default_team_post_title');
          }
        } else if ($stateParams.step === 'fundraiser') {
          if ($attrs.model === 'campaign.current.default_page_appeal') {
            this.lockField = scCampaignsTemplateService.getCampaignSettingLock('default_page_appeal');
          }
          if ($attrs.model === 'campaign.current.default_page_post_title') {
            this.lockField = scCampaignsTemplateService.getCampaignSettingLock('default_page_post_title');
          }
        }

        var isCampaignNameLocked = scCampaignsTemplateService.getCampaignLock('name');
        var isCampaignInternalNameLocked = scCampaignsTemplateService.getCampaignLock('internal_name');
        var isCampaignVenueLocked = scCampaignsTemplateService.getCampaignLock('venue');
        var isRegisterBtnTextLocked = _.get(SC.campaign.campaignTemplateData, 'components.theme.component_items[0].item_attributes.styles.registerBtnText.locked', false);
        if ($attrs.model === 'theme.styles.registerBtnText' && isRegisterBtnTextLocked) {
          this.lockField = true;
          this.disableFlag = true;
        }

        if (isCampaignNameLocked && $attrs.model === 'campaign.current.name') {
          this.lockField = true;
          this.disableFlag = true;
        }

        if (isCampaignInternalNameLocked && $attrs.model === 'campaign.current.internal_name') {
          this.lockField = true;
          this.disableFlag = true;
        }

        if (isCampaignVenueLocked && $attrs.model === 'campaign.current.venue') {
          this.lockField = true;
          this.disableFlag = true;
        }

        var urlParams = window.location.pathname.split('/');
        var urlParamId = urlParams[urlParams.length - 2];
        var urlParamIdReload = urlParams[urlParams.length - 3];
        var chosenParamId = urlParamId.length === 24 ? urlParamId : urlParamIdReload;
        var componentSetCampaign = 0;

        SC.campaign.campaignTemplateData.component_set_instances.forEach(function (item, idx) {
          if (item.campaign_id === SC.campaign.id) {
            componentSetCampaign = idx;
          }
        });

        var foundEmailId = _.filter(SC.campaign.campaignTemplateData.component_set_instances[componentSetCampaign].component_instances.message, function (data) {
          return data.id === urlParamId;
        });

        if (foundEmailId && foundEmailId[0] && foundEmailId[0].component_item_id) {
          var foundCurrentEmail = _.filter(SC.campaign.campaignTemplateData.components.message.component_items, function (data) {
            return data._id === foundEmailId[0].component_item_id.$oid;
          });

          if ($attrs.model === 'message.from') {
            this.lockField = _.get(foundCurrentEmail[0], 'item_attributes.from.locked', false);
          }
        }

        /**
         * Template locking for email content message body
         */

        if ($attrs.model === 'thisBlock.properties.altText' || $attrs.model === 'thisBlock.properties.primaryButtonLink' || $attrs.model === 'thisBlock.properties.primaryButtonText' || $attrs.model === 'thisBlock.properties.secondaryButtonLink' || $attrs.model === 'thisBlock.properties.secondaryButtonText') {
          var activeEmail = null;
          var foundEmailPayload = scCampaignsTemplateService.getEmailComponent(chosenParamId);
          activeEmail = scCampaignsTemplateService.getActiveEmail(foundEmailPayload);
          if (activeEmail) {
            var combinedBlocks = scCampaignsTemplateService.combineBlocks(activeEmail);
            _.forEach(combinedBlocks, function (value) {
              if (value.blockProp && value.blockProp.name === 'image') {
                _this.lockField = value.locked;
              }
              if (value.blockProp && value.blockProp.name === 'chargeback') {
                _this.lockField = value.locked;
              }
              if (value.blockProp && value.blockProp.name === 'button-group') {
                _this.lockField = value.locked;
              }
            });
          }
        }

        if ($attrs.model === 'thisBlock.properties.buttonText') {
          var _activeEmail = null;
          var _foundEmailPayload = scCampaignsTemplateService.getEmailComponent(chosenParamId);
          _activeEmail = scCampaignsTemplateService.getActiveEmail(_foundEmailPayload);
          if (_activeEmail) {
            var _combinedBlocks = scCampaignsTemplateService.combineBlocks(_activeEmail);
            _.forEach(_combinedBlocks, function (value) {
              if (value.blockProp && value.blockProp.name === 'commitment-achieved') {
                _this.lockField = value.locked;
              }
              if (value.blockProp && value.blockProp.name === 'commitment-updated') {
                _this.lockField = value.locked;
              }
              if (value.blockProp && value.blockProp.name === 'fundraising-commitment-waived') {
                _this.lockField = value.locked;
              }
              if (value.blockProp && value.blockProp.name === 'p2p-body') {
                _this.lockField = value.locked;
              }
            });
          }
        }
      }
      _.defaultsDeep(this, DEFAULTS);

      if (this.maxlength) {
        $element.find('.form__text-input--dark').attr('maxlength', this.maxlength);
      }

      this.pattern = this.pattern || '.*';
    };
  }]
});
})();